<template>
  <el-dialog
    class="cs-attendance-detail-dialog"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="640px"
    top="5vh"
    @close="onClose">
    <div class="attendance-detail-body">
      <el-table
        v-loading="loading"
        :data="attendanceList"
        :header-row-class-name="'el-table-header'"
        max-height="620"
        style="width: 100%">
        <el-table-column prop="ActiveTimeText" label="课节" width="120"></el-table-column>
        <el-table-column prop="SignInStatusText" label="签到" width="120">
          <template slot-scope="scope">
            <span v-if="!scope.row.SignInStatusText"><i class="el-icon-minus icon-not-sign-color"></i></span>
            <span v-else-if="isOnlineOfflineStatus(scope.row)" :class="scope.row.IsOffline ? 'cs-color-green' : 'cs-color-frenchgrey'">
              {{ scope.row.SignInStatusText }}
            </span>
            <span v-else-if="isAbnormalSignIn(scope.row)" class="make-sign-late">{{ scope.row.SignInStatusText }}</span>
            <span v-else>{{ scope.row.SignInStatusText }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="LateMinuteText" label="缺时" width="110">
          <template slot-scope="scope">
            <span :class="scope.row.LateMinuteText != '-' ? 'make-sign-late' : ''">{{ scope.row.LateMinuteText }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="WatchMinutesText" label="视频观看时长" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.WatchMinutesText || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.attendance-detail-body {
  margin: 0 16px 8px;
}

.make-sign-late {
  color: #f56c6c;
}
.icon-not-sign-color {
  color: #909399;
}
</style>

<style lang="scss">
.cs-attendance-detail-dialog {
  .el-dialog {
    min-height: 520px;
  }

  .el-dialog__body {
    padding: 16px 28px 28px !important;
  }

  .el-dialog__header {
    padding: 20px 28px 12px;
  }

  .attendance-detail-body {
    .el-table {
      .el-table__header th,
      .el-table__body td {
        padding: 8px 0;
      }

      .cell {
        padding-left: 10px;
        padding-right: 10px;
        line-height: 1.4;
      }
    }
  }
}
</style>

<script>
import { getStudentSpeedupCourseAttendanceDetail } from "../../service/student.service";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    studentId: Number,
    courseId: Number,
    termId: Number,
    campusId: Number,
    courseName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      attendanceList: [],
      dialogVisible: false
    };
  },
  computed: {
    dialogTitle() {
      return this.courseName ? `课程签到明细 - ${this.courseName}` : "课程签到明细";
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.loadData();
        }
      }
    }
  },
  methods: {
    isOnlineOfflineStatus(row) {
      const text = row.SignInStatusText;
      return text === "线上签到" || text === "线下签到";
    },
    isAbnormalSignIn(row) {
      const text = row.SignInStatusText;
      return text && text !== "正常" && text !== "不计签到" && text !== "线上签到" && text !== "线下签到";
    },
    loadData() {
      if (!this.studentId || !this.courseId || !this.termId) {
        this.attendanceList = [];
        return;
      }
      this.loading = true;
      this.attendanceList = [];
      getStudentSpeedupCourseAttendanceDetail(
        this.studentId,
        this.courseId,
        this.termId,
        this.campusId
      )
        .then(result => {
          if (result && result.success) {
            this.attendanceList = result.data || [];
          } else {
            this.attendanceList = [];
            if (result && result.message) {
              this.$message.error(result.message);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/studentProfile/studentCourseAttendanceDetailDialog.vue